

export default {


  data() {
    return {
      loading_suscripciones: false,
      suscripcion_actual:"",
      suscripcion_id:null,
      loading_documento_finalizacion: false,
      src_contrato:""
    }
  },

  async created(){
    await this.getSuscripcionActual();
    await this.docu_suscripcion();
  },

  methods: {

    async getSuscripcionActual() {
      try {
        this.loading_documento_finalizacion = true;
        this.loading_suscripciones = true;
        let r = await this.$store.state.services.usuarioService.getSuscripcionActual();
        this.suscripcion_actual = r.data.data[0].tipo_suscripcion_id;
        this.suscripcion_id = r.data.data[0].id;
        this.loading_suscripciones = false;
      } catch (error) {
        console.log(error);
        this.loading_suscripciones = false;
      }
    },

    async docu_suscripcion() {


      try {
        this.loading_documento_finalizacion = true;
        let r = await this.$store.state.services.usuarioService.getDocumentoSuscripcion(this.suscripcion_id)
        console.log("respuesta documento",r);
        this.src_contrato = r.data.data;
        this.loading_documento_finalizacion = false;

      } catch (error) {
        this.loading_documento_finalizacion = false;
        console.log(error);
        this.$toast.error("No es posible obtener el documento para finalizar suscripción")
      }
    
    },



  }


}